const indexItems = [
  { title: '科幻巅峰', desc: '20部史诗级科幻巨制，探索宇宙与未来的无限可能', count: '20部', icon: 'ri-rocket-line', color: 'primary' },
  { title: '悬疑烧脑', desc: '高智商犯罪与反转剧情，挑战你的推理极限', count: '35部', icon: 'ri-search-eye-line', color: 'accent' },
  { title: '古装风华', desc: '从秦汉到明清，经典古装大剧一网打尽', count: '48部', icon: 'ri-ancient-gate-line', color: 'secondary' },
  { title: '日韩精选', desc: '最新日剧韩剧同步更新，千部热门剧集任你选', count: '1000+部', icon: 'ri-global-line', color: 'primary' },
  { title: '动漫世界', desc: '热血、治愈、奇幻——全类型动漫番剧持续更新', count: '200+部', icon: 'ri-emotion-line', color: 'accent' },
  { title: '喜剧合家欢', desc: '轻松一笑，全家共享的欢乐影视时光', count: '60部', icon: 'ri-emotion-happy-line', color: 'secondary' },
  { title: '纪录片精选', desc: 'BBC、NHK顶级纪录片，足不出户看世界', count: '80部', icon: 'ri-earth-line', color: 'primary' },
];

function getColorClasses(color: string) {
  switch (color) {
    case 'primary':
      return { bg: 'bg-primary-500/10', icon: 'text-primary-400', badge: 'bg-primary-500/15 text-primary-400', border: 'hover:border-primary-500/30' };
    case 'accent':
      return { bg: 'bg-accent-500/10', icon: 'text-accent-400', badge: 'bg-accent-500/15 text-accent-400', border: 'hover:border-accent-500/30' };
    case 'secondary':
      return { bg: 'bg-secondary-500/10', icon: 'text-secondary-400', badge: 'bg-secondary-500/15 text-secondary-400', border: 'hover:border-secondary-500/30' };
    default:
      return { bg: 'bg-primary-500/10', icon: 'text-primary-400', badge: 'bg-primary-500/15 text-primary-400', border: 'hover:border-primary-500/30' };
  }
}

export default function Index() {
  return (
    <section id="index" className="relative py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full mb-4">
            专题合集
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            精选影视专题合集
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-2xl mx-auto">
            按类型与主题精心整理，快速找到你想看的影视内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item, idx) => {
            const colors = getColorClasses(item.color);
            return (
              <div
                key={idx}
                className={`group bg-background-200/60 rounded-xl p-5 border border-background-300/20 transition-all duration-300 cursor-pointer ${colors.border}`}
              >
                <div className={`w-11 h-11 rounded-xl ${colors.bg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${item.icon} ${colors.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                  {item.desc}
                </p>
                <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${colors.badge}`}>
                  {item.count}
                </span>
              </div>
            );
          })}
          {/* 合集统计卡片 */}
          <div className="hidden lg:flex bg-background-200/40 rounded-xl p-5 border border-background-300/15 items-center justify-center flex-col gap-3">
            <div className="w-14 h-14 rounded-full bg-primary-500/10 flex items-center justify-center">
              <i className="ri-stack-line text-primary-400 text-2xl"></i>
            </div>
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-primary-400">7大</div>
              <div className="text-xs text-foreground-500">精选专题</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-accent-400">1400+</div>
              <div className="text-xs text-foreground-500">部精选影片</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}